import React from 'react'
import config from 'config'

import RichCta from 'components/rich-cta'
import MortgageCombinedForm from 'components/form/mortgage-combined'
import WidgetPage from 'components/hocs/widget-page'

export const RichCtaApp = (props) => (
  <RichCta
    nmls
    url={`${config.credibleRoot}/mortgage-refinance`}
    title="Find the right mortgage for your dream home."
    body="Get and compare prequalified rates from multiple lenders in minutes"
    ctaText="Get Started"
    form={MortgageCombinedForm}
    {...props}
  />
)

export default WidgetPage(RichCtaApp)
